export default "__VITE_ASSET__961bd00f__"